<template>
    <div class="absolute top-[50%] translate-y-[-50%] translate-x-[-50%] text-sm"
         :title="infoContent"
         v-bind:class="[eventHappenedBeforeTimelineStart ? 'hidden' : '', type]"
         :style="{left: left + '%'}">
        <i class="fas" :class="icon"></i>
    </div>
</template>

<script lang="ts">
    import {defineComponent} from 'vue';
    import {MileStoneType} from "./types";

    export default defineComponent({
        name: 'event',
        props: {
            date: {
                required: true,
                type: Number
            },
            type: String as () => MileStoneType,
            info: String,
            timelineStart: {
                required: true,
                type: Number
            },
            timelineEnd: {
                required: true,
                type: Number
            }
        },
        computed: {
            eventHappenedBeforeTimelineStart(): boolean {
                return this.date < +this.timelineStart;
            },
            left(): number {
                return (Date.fromHansDate(this.date).getTime() - Date.fromHansDate(this.timelineStart).getTime()) /
                    (Date.fromHansDate(this.timelineEnd).getTime() - Date.fromHansDate(this.timelineStart).getTime()) * 100;
            },
            infoContent(): string {
                return this.info + ': ' + Date.fromHansDate(this.date).toDateString();
            },
            icon(): string {
                switch (this.type) {
                    case MileStoneType.OPRICHTING:
                        return "text-primary-400 fa-seedling";
                    case MileStoneType.STOPZETTING:
                        return "text-barometer-red fa-circle-minus";
                    case MileStoneType.OPENING_FAILLISSEMENT:
                        return "text-barometer-red fa-gavel";
                    case MileStoneType.SLUITING_FAILLISSEMENT:
                        return "text-barometer-red fa-gavel";
                    case MileStoneType.INTREKKING_FAILLISSEMENT:
                        return "text-barometer-red fa-gavel";
                    default:
                        return "fa-circle text-barometer-red text-[7px]";
                }
            }
        }
    });
</script>